module.exports = " <div class=\"datepicker-container fill\" _v-3b082267=\"\"> <vue-datepicker :time.sync=time :type=type :option=option :limit=limit :locale=locale :minute-label=minuteLabel :hour-label=hourLabel _v-3b082267=\"\"></vue-datepicker> <slot _v-3b082267=\"\"></slot> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-3b082267!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/client/components/Datepicker.vue
// module id = 350
// module chunks = 0